function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgScanSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48"
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      blockProgression: "tb",
      whiteSpace: "normal",
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    d: "M20.16 0C9.05 0 0 9.051 0 20.16c0 11.108 9.051 20.16 20.16 20.16 4.855 0 9.317-1.73 12.803-4.606L44.688 47.44a1.97 1.97 0 002.752 0 1.97 1.97 0 000-2.752L35.715 32.963a20.061 20.061 0 004.604-12.803C40.32 9.05 31.268 0 20.16 0zm0 4.291c8.79 0 15.869 7.08 15.869 15.869 0 8.79-7.08 15.869-15.87 15.869-8.789 0-15.868-7.08-15.868-15.87 0-8.789 7.08-15.868 15.869-15.868z",
    color: "#000",
    fontWeight: 400,
    fontFamily: "sans-serif",
    overflow: "visible",
    fill: "#fff"
  }));
}

export default SvgScanSearch;